function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1086_400)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165 -0.000976562H0V164.999H165V-0.000976562Z",
  fill: "#DDE9AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.939 -0.000976562L123.816 0.0986318L123.798 0.114257C121.429 11.0352 118.478 21.8211 115.931 32.7C112.608 45.2729 108.275 57.7649 107.73 70.8818C106.473 79.5444 107.145 88.4026 109.433 96.8446C110.236 100.673 111.864 104.378 112.38 108.218C111.484 123.353 109.091 138.368 108.745 153.547C108.584 157.338 108.453 161.129 108.308 164.92C108.405 164.953 108.511 164.97 108.613 164.998H164.999V-0.000622565H123.938L123.939 -0.000976562Z",
  fill: "#F3CB6B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.0393 24.5949C26.0115 30.5417 38.6012 32.4107 32.5965 25.7188C31.8124 24.7106 30.3244 23.7697 29.0393 24.5949V24.5949Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.5493 34.6854C41.0159 28.1755 28.3543 29.4711 35.8248 34.4742C36.8335 35.2577 38.5076 35.8023 39.5493 34.6854V34.6854Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.0925 29.4368C44.6129 25.6874 34.4849 17.9787 36.5183 26.7369C36.719 27.9982 37.5688 29.54 39.0925 29.4368V29.4368Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9501 137.012C23.3559 135.987 25.5016 148.533 29.9902 140.742C30.704 139.683 31.1345 137.976 29.9501 137.012Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8694 127.953C18.5534 132.706 24.3078 121.353 16.0605 124.933C14.8561 125.359 13.4929 126.473 13.8694 127.953Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0518 81.6118C49.3932 87.8609 59.2733 79.8371 50.2827 79.747C49.0096 79.6445 47.3109 80.1067 47.0518 81.6118Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.7436 133.048C26.8181 127.05 17.7465 135.977 26.7047 135.212C27.9818 135.192 29.6288 134.571 29.7436 133.048Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.942 34.8037C40.8539 37.5363 49.4874 46.8884 49.0077 37.91C49.0293 36.633 48.4605 34.967 46.942 34.8037Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8924 37.7349C32.8421 43.114 40.1736 32.71 31.4961 35.0633C30.243 35.3102 28.7334 36.216 28.8924 37.7349Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.0043 35.1976C49.4859 33.6104 42.6851 22.852 41.5341 31.769C41.282 33.0211 41.5405 34.7625 43.0043 35.1976Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.3753 39.4282C40.051 44.9977 47.8934 34.9732 39.1092 36.89C37.8452 37.074 36.2923 37.9032 36.3753 39.4282Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9368 33.883C31.3039 27.3512 18.6635 28.8403 26.2095 33.7287C27.23 34.4967 28.9123 35.0156 29.9368 33.883Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.0663 79.6693C50.0943 76.8064 41.2618 67.6423 41.9343 76.608C41.94 77.8852 42.5446 79.5387 44.0663 79.6693Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1276 82.0692C36.6718 85.9118 46.9288 93.4475 44.7473 84.725C44.5252 83.4673 43.6494 81.9401 42.1276 82.0692Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.2958 80.6748C30.6332 81.0537 35.3587 92.8718 38.1162 84.3139C38.5924 83.1288 38.6559 81.3694 37.2958 80.6748Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.6542 127.692C27.1474 121.191 16.3057 127.858 25.2077 129.12C26.4566 129.387 28.2011 129.151 28.6542 127.692Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.0612 77.4549C41.2019 70.7832 29.0521 74.5748 37.3693 77.9897C38.5138 78.5567 40.2628 78.7568 41.0612 77.4549Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0171 90.6679C19.5965 89.5533 13.591 78.3314 11.7985 87.1421C11.4566 88.3726 11.5884 90.1282 13.0171 90.6679Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6303 86.0865C14.6986 80.7966 2.66568 76.6482 7.33993 84.3287C7.92561 85.4637 9.21557 86.6618 10.6303 86.0865Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6718 140.456C17.3271 143.998 20.3027 131.623 13.1059 137.012C12.0323 137.704 10.9634 139.103 11.6718 140.456Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1028 129.578C5.71124 131.497 13.0566 141.891 13.7474 132.927C13.9348 131.663 13.5873 129.937 12.1028 129.578Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9569 134.272C21.2588 138.324 25.3717 126.28 17.7049 130.976C16.5716 131.565 15.3774 132.859 15.9569 134.272Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8269 135.683C15.5275 137.885 23.3309 147.94 23.6197 138.954C23.7504 137.683 23.3259 135.975 21.8269 135.683Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.26 2.44043C122.454 6.0331 121.603 9.61518 120.721 13.1904H164.995V2.44043H123.26H123.26Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.25 19.1895C118.354 22.7694 117.469 26.3516 116.607 29.9394H164.998V19.1895H119.25H119.25Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.17 35.4395C114.189 39.0192 113.175 42.5982 112.197 46.1894H164.996V35.4395H115.17H115.17Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.859 51.3145C109.974 54.8707 109.214 58.4504 108.648 62.0644H165V51.3145H110.859H110.859Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.97 67.6895C107.877 68.7514 107.77 69.8108 107.726 70.8808C107.362 73.3891 107.178 75.9131 107.13 78.4394H164.994V67.6895H107.97H107.97Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.319 84.6279C107.605 88.249 108.201 91.8449 109.075 95.3779H165.001V84.6279H107.319H107.319Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.502 9.16113V12.9259H125.351V9.16113H124.502Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.857 11.394H126.049C126.049 8.94046 125.519 2.6251 124.892 2.68103C124.3 2.76467 123.665 8.94034 123.665 11.394H124.857Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.206 9.16113V12.9259H131.055V9.16113H130.206Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.557 11.394H131.75C131.75 8.94046 131.22 2.6251 130.592 2.68103C130 2.76467 129.365 8.94034 129.365 11.394H130.557Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.711 9.16113V12.9259H135.56V9.16113H134.711Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.066 11.394H136.258C136.258 8.94046 135.728 2.6251 135.101 2.68103C134.509 2.76467 133.874 8.94034 133.874 11.394H135.066Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.963 9.16113V12.9259H139.812V9.16113H138.963Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.318 11.394H140.51C140.51 8.94046 139.98 2.6251 139.353 2.68103C138.761 2.76467 138.126 8.94034 138.126 11.394H139.318Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.397 9.16113V12.9259H145.246V9.16113H144.397Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.753 11.394H145.945C145.945 8.94046 145.415 2.6251 144.788 2.68103C144.195 2.76467 143.561 8.94034 143.561 11.394H144.753Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.272 9.16113V12.9259H152.121V9.16113H151.272Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.628 11.394H152.82C152.82 8.94046 152.29 2.6251 151.663 2.68103C151.07 2.76467 150.436 8.94034 150.436 11.394H151.628Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.524 9.16113V12.9259H156.373V9.16113H155.524Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.88 11.394H157.072C157.072 8.94046 156.542 2.6251 155.915 2.68103C155.322 2.76467 154.688 8.94034 154.688 11.394H155.88Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.144 25.9111V29.6759H122.992V25.9111H122.144Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.495 28.144H123.687C123.687 25.6905 123.157 19.3751 122.53 19.431C121.937 19.5147 121.303 25.6903 121.303 28.144H122.495Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.331 25.9111V29.6759H129.18V25.9111H128.331Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.682 28.144H129.875C129.875 25.6905 129.345 19.3751 128.717 19.431C128.125 19.5147 127.49 25.6903 127.49 28.144H128.682Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.03 25.9111V29.6759H134.879V25.9111H134.03Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.386 28.144H135.578C135.578 25.6905 135.048 19.3751 134.42 19.431C133.828 19.5147 133.193 25.6903 133.193 28.144H134.386Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.539 25.9111V29.6759H139.388V25.9111H138.539Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.891 28.144H140.084C140.084 25.6905 139.554 19.3751 138.926 19.431C138.334 19.5147 137.699 25.6903 137.699 28.144H138.891Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.788 25.9111V29.6759H143.637V25.9111H142.788Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.143 28.144H144.336C144.336 25.6905 143.806 19.3751 143.178 19.431C142.586 19.5147 141.951 25.6903 141.951 28.144H143.143Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.227 25.9111V29.6759H149.075V25.9111H148.227Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.582 28.144H149.774C149.774 25.6905 149.244 19.3751 148.617 19.431C148.024 19.5147 147.39 25.6903 147.39 28.144H148.582Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.102 25.9111V29.6759H155.95V25.9111H155.102Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.457 28.144H156.649C156.649 25.6905 156.119 19.3751 155.492 19.431C154.899 19.5147 154.265 25.6903 154.265 28.144H155.457Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.35 25.9111V29.6759H160.199V25.9111H159.35Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.705 28.144H160.897C160.897 25.6905 160.367 19.3751 159.74 19.431C159.147 19.5147 158.513 25.6903 158.513 28.144H159.705Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.375 42.0859V45.8507H121.224V42.0859H120.375Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.73 44.3188H121.923C121.923 41.8653 121.392 35.5499 120.765 35.6058C120.173 35.6895 119.538 41.8651 119.538 44.3188H120.73Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.326 42.0859V45.8507H126.175V42.0859H125.326Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.678 44.3188H126.87C126.87 41.8653 126.34 35.5499 125.712 35.6058C125.12 35.6895 124.485 41.8651 124.485 44.3188H125.678Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.514 42.0859V45.8507H132.363V42.0859H131.514Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.865 44.3188H133.057C133.057 41.8653 132.527 35.5499 131.9 35.6058C131.307 35.6895 130.673 41.8651 130.673 44.3188H131.865Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.213 42.0859V45.8507H138.062V42.0859H137.213Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.568 44.3188H138.76C138.76 41.8653 138.23 35.5499 137.603 35.6058C137.011 35.6895 136.376 41.8651 136.376 44.3188H137.568Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.722 42.0859V45.8507H142.571V42.0859H141.722Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.073 44.3188H143.265C143.265 41.8653 142.735 35.5499 142.108 35.6058C141.515 35.6895 140.881 41.8651 140.881 44.3188H142.073Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.97 42.0859V45.8507H146.819V42.0859H145.97Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.325 44.3188H147.517C147.517 41.8653 146.987 35.5499 146.36 35.6058C145.767 35.6895 145.133 41.8651 145.133 44.3188H146.325Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.409 42.0859V45.8507H152.258V42.0859H151.409Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.764 44.3188H152.957C152.957 41.8653 152.427 35.5499 151.799 35.6058C151.207 35.6895 150.572 41.8651 150.572 44.3188H151.764Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.284 42.0859V45.8507H159.133V42.0859H158.284Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.639 44.3188H159.832C159.832 41.8653 159.302 35.5499 158.674 35.6058C158.082 35.6895 157.447 41.8651 157.447 44.3188H158.639Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.053 57.9062V61.671H122.902V57.9062H122.053Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.408 60.1401H123.6C123.6 57.6866 123.07 51.3712 122.443 51.4271C121.85 51.5108 121.216 57.6864 121.216 60.1401H122.408Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.004 57.9062V61.671H127.853V57.9062H127.004Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.359 60.1401H128.551C128.551 57.6866 128.021 51.3712 127.394 51.4271C126.802 51.5108 126.167 57.6864 126.167 60.1401H127.359Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.191 57.9062V61.671H134.04V57.9062H133.191Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.547 60.1401H134.739C134.739 57.6866 134.209 51.3712 133.582 51.4271C132.989 51.5108 132.354 57.6864 132.354 60.1401H133.547Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.891 57.9062V61.671H139.74V57.9062H138.891Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.246 60.1401H140.438C140.438 57.6866 139.908 51.3712 139.281 51.4271C138.688 51.5108 138.054 57.6864 138.054 60.1401H139.246Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.4 57.9062V61.671H144.249V57.9062H143.4Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.756 60.1401H144.948C144.948 57.6866 144.418 51.3712 143.791 51.4271C143.198 51.5108 142.563 57.6864 142.563 60.1401H143.756Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.648 57.9062V61.671H148.497V57.9062H147.648Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.004 60.1401H149.196C149.196 57.6866 148.666 51.3712 148.039 51.4271C147.446 51.5108 146.812 57.6864 146.812 60.1401H148.004Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.087 57.9062V61.671H153.936V57.9062H153.087Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.442 60.1401H154.634C154.634 57.6866 154.104 51.3712 153.477 51.4271C152.885 51.5108 152.25 57.6864 152.25 60.1401H153.442Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.903 57.9062V61.671H159.752V57.9062H158.903Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.256 60.1401H160.448C160.448 57.6866 159.918 51.3712 159.291 51.4271C158.698 51.5108 158.063 57.6864 158.063 60.1401H159.256Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.26 74.2832V78.048H122.109V74.2832H121.26Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.611 76.5132H122.803C122.803 74.0596 122.273 67.7442 121.646 67.8002C121.054 67.8838 120.419 74.0595 120.419 76.5132H121.611Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.207 74.2832V78.048H127.056V74.2832H126.207Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.562 76.5132H127.755C127.755 74.0596 127.224 67.7442 126.597 67.8002C126.005 67.8838 125.37 74.0595 125.37 76.5132H126.562Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.394 74.2832V78.048H133.242V74.2832H132.394Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.749 76.5132H133.941C133.941 74.0596 133.411 67.7442 132.784 67.8002C132.191 67.8838 131.557 74.0595 131.557 76.5132H132.749Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.098 74.2832V78.048H138.947V74.2832H138.098Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.453 76.5132H139.645C139.645 74.0596 139.115 67.7442 138.488 67.8002C137.895 67.8838 137.261 74.0595 137.261 76.5132H138.453Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.606 74.2832V78.048H143.455V74.2832H142.606Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.958 76.5132H144.15C144.15 74.0596 143.62 67.7442 142.993 67.8002C142.4 67.8838 141.766 74.0595 141.766 76.5132H142.958Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.854 74.2832V78.048H147.703V74.2832H146.854Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.21 76.5132H148.402C148.402 74.0596 147.872 67.7442 147.245 67.8002C146.652 67.8838 146.018 74.0595 146.018 76.5132H147.21Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.293 74.2832V78.048H153.142V74.2832H152.293Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.644 76.5132H153.837C153.837 74.0596 153.307 67.7442 152.679 67.8002C152.087 67.8838 151.452 74.0595 151.452 76.5132H152.644Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.106 74.2832V78.048H158.955V74.2832H158.106Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.462 76.5132H159.654C159.654 74.0596 159.124 67.7442 158.497 67.8002C157.904 67.8838 157.27 74.0595 157.27 76.5132H158.462Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.087 9.16113V12.9259H160.936V9.16113H160.087Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.442 11.394H161.634C161.634 8.94046 161.104 2.6251 160.477 2.68103C159.885 2.76467 159.25 8.94034 159.25 11.394H160.442Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.971 42.0859V45.8507H163.82V42.0859H162.971Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.326 44.3188H164.518C164.518 41.8653 163.988 35.5499 163.361 35.6058C162.768 35.6895 162.134 41.8651 162.134 44.3188H163.326Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.035 57.9062V61.671H163.884V57.9062H163.035Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.39 60.1401H164.583C164.583 57.6866 164.053 51.3712 163.425 51.4271C162.833 51.5108 162.198 57.6864 162.198 60.1401H163.39Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.805 74.2832V78.048H163.654V74.2832H162.805Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.156 76.5132H164.348C164.348 74.0596 163.818 67.7442 163.191 67.8002C162.598 67.8838 161.964 74.0595 161.964 76.5132H163.156Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.67 101.378C111.363 103.646 112.072 105.909 112.383 108.218C112.306 109.522 112.205 110.825 112.107 112.128H165.002V101.378H110.67H110.67Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.649 117.628C111.325 121.214 110.965 124.795 110.603 128.378H164.997V117.628H111.65H111.649Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.12 133.498C109.773 137.078 109.446 140.66 109.2 144.248H165.001V133.498H110.12H110.12Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.89 149.878C108.837 151.101 108.777 152.323 108.749 153.548C108.649 155.907 108.565 158.268 108.478 160.628H165.002V149.878H108.89H108.89Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.428 42.085V45.8497H116.277V42.085H115.428Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.783 44.3188H116.975C116.975 41.8653 116.445 35.5499 115.818 35.6058C115.225 35.6895 114.591 41.8651 114.591 44.3188H115.783Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.618 57.9062V61.671H117.467V57.9062H116.618Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.973 60.1401H118.166C118.166 57.6866 117.636 51.3712 117.008 51.4271C116.416 51.5108 115.781 57.6864 115.781 60.1401H116.973Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.613 74.2832V78.048H114.462V74.2832H113.613Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.966 76.5132H115.158C115.158 74.0596 114.628 67.7442 114.001 67.8002C113.408 67.8838 112.773 74.0595 112.773 76.5132H113.966Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.118 91.5215V95.2863H115.967V91.5215H115.118Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.47 93.7514H116.662C116.662 91.2979 116.132 84.9825 115.504 85.0385C114.912 85.1221 114.277 91.2978 114.277 93.7514H115.47Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.995 91.5215V95.2863H121.844V91.5215H120.995Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.347 93.7514H122.539C122.539 91.2979 122.009 84.9825 121.381 85.0385C120.789 85.1221 120.154 91.2978 120.154 93.7514H121.347Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.785 91.5215V95.2863H127.634V91.5215H126.785Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.137 93.7514H128.329C128.329 91.2979 127.799 84.9825 127.171 85.0385C126.579 85.1221 125.944 91.2978 125.944 93.7514H127.137Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.076 91.5215V95.2863H134.925V91.5215H134.076Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.428 93.7514H135.62C135.62 91.2979 135.09 84.9825 134.462 85.0385C133.87 85.1221 133.235 91.2978 133.235 93.7514H134.428Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.234 91.5215V95.2863H142.083V91.5215H141.234Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.586 93.7514H142.778C142.778 91.2979 142.248 84.9825 141.621 85.0385C141.028 85.1221 140.394 91.2978 140.394 93.7514H141.586Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.434 91.5215V95.2863H146.283V91.5215H145.434Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.785 93.7514H146.977C146.977 91.2979 146.447 84.9825 145.82 85.0385C145.227 85.1221 144.593 91.2978 144.593 93.7514H145.785Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.844 91.5215V95.2863H152.693V91.5215H151.844Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.195 93.7514H153.387C153.387 91.2979 152.857 84.9825 152.23 85.0385C151.638 85.1221 151.003 91.2978 151.003 93.7514H152.195Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.196 91.5215V95.2863H161.045V91.5215H160.196Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.548 93.7514H161.74C161.74 91.2979 161.21 84.9825 160.583 85.0385C159.99 85.1221 159.355 91.2978 159.355 93.7514H160.548Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.145 108.155V111.92H122.993V108.155H122.145Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.496 110.389H123.688C123.688 107.936 123.158 101.62 122.531 101.676C121.938 101.76 121.304 107.935 121.304 110.389H122.496Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.331 108.155V111.92H129.18V108.155H128.331Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.682 110.389H129.875C129.875 107.936 129.345 101.62 128.717 101.676C128.125 101.76 127.49 107.935 127.49 110.389H128.682Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.031 108.155V111.92H134.88V108.155H134.031Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.387 110.389H135.579C135.579 107.936 135.049 101.62 134.421 101.676C133.829 101.76 133.194 107.935 133.194 110.389H134.387Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.54 108.155V111.92H139.389V108.155H138.54Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.891 110.389H140.084C140.084 107.936 139.554 101.62 138.926 101.676C138.334 101.76 137.699 107.935 137.699 110.389H138.891Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.788 108.155V111.92H143.637V108.155H142.788Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.143 110.389H144.336C144.336 107.936 143.806 101.62 143.178 101.676C142.586 101.76 141.951 107.935 141.951 110.389H143.143Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.227 108.155V111.92H149.075V108.155H148.227Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.582 110.389H149.774C149.774 107.936 149.244 101.62 148.617 101.676C148.024 101.76 147.39 107.935 147.39 110.389H148.582Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.102 108.155V111.92H155.95V108.155H155.102Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.457 110.389H156.649C156.649 107.936 156.119 101.62 155.492 101.676C154.899 101.76 154.265 107.935 154.265 110.389H155.457Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.35 108.155V111.92H160.199V108.155H159.35Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.705 110.389H160.897C160.897 107.936 160.367 101.62 159.74 101.676C159.147 101.76 158.513 107.935 158.513 110.389H159.705Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.375 124.332V128.097H121.224V124.332H120.375Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.73 126.566H121.923C121.923 124.112 121.392 117.797 120.765 117.853C120.173 117.937 119.538 124.112 119.538 126.566H120.73Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.326 124.332V128.097H126.175V124.332H125.326Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.679 126.566H126.871C126.871 124.112 126.341 117.797 125.713 117.853C125.121 117.937 124.486 124.112 124.486 126.566H125.679Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.514 124.332V128.097H132.363V124.332H131.514Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.865 126.566H133.057C133.057 124.112 132.527 117.797 131.9 117.853C131.307 117.937 130.673 124.112 130.673 126.566H131.865Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.213 124.332V128.097H138.062V124.332H137.213Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.568 126.566H138.76C138.76 124.112 138.23 117.797 137.603 117.853C137.011 117.937 136.376 124.112 136.376 126.566H137.568Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.723 124.332V128.097H142.572V124.332H141.723Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.074 126.566H143.266C143.266 124.112 142.736 117.797 142.109 117.853C141.516 117.937 140.882 124.112 140.882 126.566H142.074Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.971 124.332V128.097H146.82V124.332H145.971Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.326 126.566H147.518C147.518 124.112 146.988 117.797 146.361 117.853C145.768 117.937 145.134 124.112 145.134 126.566H146.326Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.409 124.332V128.097H152.258V124.332H151.409Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.764 126.566H152.957C152.957 124.112 152.427 117.797 151.799 117.853C151.207 117.937 150.572 124.112 150.572 126.566H151.764Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.284 124.332V128.097H159.133V124.332H158.284Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.639 126.566H159.832C159.832 124.112 159.302 117.797 158.674 117.853C158.082 117.937 157.447 124.112 157.447 126.566H158.639Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.054 140.153V143.918H122.903V140.153H122.054Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.409 142.387H123.601C123.601 139.934 123.071 133.618 122.444 133.674C121.851 133.758 121.217 139.934 121.217 142.387H122.409Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.005 140.153V143.918H127.854V140.153H127.005Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.36 142.387H128.552C128.552 139.934 128.022 133.618 127.395 133.674C126.803 133.758 126.168 139.934 126.168 142.387H127.36Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.191 140.153V143.918H134.04V140.153H133.191Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.547 142.387H134.739C134.739 139.934 134.209 133.618 133.582 133.674C132.989 133.758 132.354 139.934 132.354 142.387H133.547Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.892 140.153V143.918H139.741V140.153H138.892Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.247 142.387H140.439C140.439 139.934 139.909 133.618 139.282 133.674C138.689 133.758 138.055 139.934 138.055 142.387H139.247Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.4 140.153V143.918H144.249V140.153H143.4Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.756 142.387H144.948C144.948 139.934 144.418 133.618 143.791 133.674C143.198 133.758 142.563 139.934 142.563 142.387H143.756Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.648 140.153V143.918H148.497V140.153H147.648Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.004 142.387H149.196C149.196 139.934 148.666 133.618 148.039 133.674C147.446 133.758 146.812 139.934 146.812 142.387H148.004Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.087 140.153V143.918H153.936V140.153H153.087Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.442 142.387H154.634C154.634 139.934 154.104 133.618 153.477 133.674C152.885 133.758 152.25 139.934 152.25 142.387H153.442Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.904 140.153V143.918H159.753V140.153H158.904Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.256 142.387H160.448C160.448 139.934 159.918 133.618 159.291 133.674C158.698 133.758 158.063 139.934 158.063 142.387H159.256Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.26 156.53V160.295H122.109V156.53H121.26Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.611 158.76H122.803C122.803 156.307 122.273 149.991 121.646 150.047C121.054 150.131 120.419 156.307 120.419 158.76H121.611Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.207 156.53V160.295H127.056V156.53H126.207Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.562 158.76H127.755C127.755 156.307 127.224 149.991 126.597 150.047C126.005 150.131 125.37 156.307 125.37 158.76H126.562Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.395 156.53V160.295H133.243V156.53H132.395Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.75 158.76H133.942C133.942 156.307 133.412 149.991 132.785 150.047C132.192 150.131 131.558 156.307 131.558 158.76H132.75Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.098 156.53V160.295H138.947V156.53H138.098Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.453 158.76H139.645C139.645 156.307 139.115 149.991 138.488 150.047C137.895 150.131 137.261 156.307 137.261 158.76H138.453Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.606 156.53V160.295H143.455V156.53H142.606Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.958 158.76H144.15C144.15 156.307 143.62 149.991 142.993 150.047C142.4 150.131 141.766 156.307 141.766 158.76H142.958Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.854 156.53V160.295H147.703V156.53H146.854Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.21 158.76H148.402C148.402 156.307 147.872 149.991 147.245 150.047C146.652 150.131 146.018 156.307 146.018 158.76H147.21Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.294 156.53V160.295H153.143V156.53H152.294Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.645 158.76H153.838C153.838 156.307 153.307 149.991 152.68 150.047C152.088 150.131 151.453 156.307 151.453 158.76H152.645Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.106 156.53V160.295H158.955V156.53H158.106Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.462 158.76H159.654C159.654 156.307 159.124 149.991 158.497 150.047C157.904 150.131 157.27 156.307 157.27 158.76H158.462Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.971 124.332V128.097H163.82V124.332H162.971Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.326 126.566H164.518C164.518 124.112 163.988 117.797 163.361 117.853C162.768 117.937 162.134 124.112 162.134 126.566H163.326Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.035 140.153V143.918H163.884V140.153H163.035Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.39 142.387H164.583C164.583 139.934 164.053 133.618 163.425 133.674C162.833 133.758 162.198 139.934 162.198 142.387H163.39Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.805 156.53V160.295H163.654V156.53H162.805Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.156 158.76H164.348C164.348 156.307 163.818 149.991 163.191 150.047C162.598 150.131 161.964 156.307 161.964 158.76H163.156Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.802 108.155V111.92H116.651V108.155H115.802Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.153 110.389H117.345C117.345 107.936 116.815 101.62 116.188 101.676C115.596 101.76 114.961 107.935 114.961 110.389H116.153Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.784 124.332V128.097H114.633V124.332H113.784Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.139 126.566H115.332C115.332 124.112 114.802 117.797 114.174 117.853C113.582 117.937 112.947 124.112 112.947 126.566H114.139Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.646 140.153V143.918H118.495V140.153H117.646Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.002 142.387H119.194C119.194 139.934 118.664 133.618 118.037 133.674C117.444 133.758 116.81 139.934 116.81 142.387H118.002Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.491 140.153V143.918H113.34V140.153H112.491Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.847 142.387H114.039C114.039 139.934 113.509 133.618 112.881 133.674C112.289 133.758 111.654 139.934 111.654 142.387H112.847Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.418 156.53V160.295H117.267V156.53H116.418Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.769 158.76H117.962C117.962 156.307 117.432 149.991 116.804 150.047C116.212 150.131 115.577 156.307 115.577 158.76H116.769Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.979 156.53V160.295H111.828V156.53H110.979Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.331 158.76H112.523C112.523 156.307 111.993 149.991 111.366 150.047C110.773 150.131 110.139 156.307 110.139 158.76H111.331Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.0918 -0.000905132L57.0078 0.0694064C55.555 7.17236 56.2865 14.5323 58.0488 21.5103C60.0282 29.6208 62.6843 37.5671 65.5859 45.3751C68.2541 54.4862 66.5905 64.067 65.3242 73.2699C64.4696 79.2195 64.1066 85.3048 64.8652 91.2798C66.1758 95.0191 67.4887 98.869 67.3925 102.885C67.7645 111.935 63.1546 120.133 58.7011 127.68C56.0744 132.152 52.8205 136.42 51.7598 141.611C49.7276 149.183 48.9502 157.49 51.7852 164.966C51.8617 164.984 51.9442 164.982 52.0215 164.998H107.808C108.354 164.131 108.042 162.722 108.238 161.673C108.65 150.186 109.052 138.707 110.48 127.299C111.037 120.867 112.3 114.431 111.892 107.957C111.083 102.599 109.041 97.5098 108.115 92.1738C106.708 85.7569 106.482 79.1419 107.373 72.6229C107.789 65.2019 108.665 57.7881 110.726 50.6251C113.291 41.1295 116.183 31.7052 118.249 22.0763C120.004 14.7797 121.993 7.5344 123.552 0.189456C123.473 0.107432 123.375 0.0535965 123.279 -0.00195312H57.091L57.0918 -0.000905132Z",
  fill: "#D5864E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.41 -0.000441305C121.455 10.1885 118.159 20.1774 116.208 30.4215C112.725 44.1307 107.246 57.5016 107.46 71.9739C104.893 84.0976 108.591 96.0179 111.948 107.392C111.817 118.924 109.575 130.362 108.892 141.925C108.371 149.651 108.377 157.339 107.915 165H108.413C108.877 157.328 108.874 149.65 109.394 141.955C110.075 130.431 112.32 118.984 112.45 107.386V107.349L112.435 107.312C109.066 95.8996 105.395 84.0261 107.954 72.0249L107.962 71.9958V71.9663C107.75 57.6199 113.2 44.2845 116.694 30.5236V30.5077C118.643 20.2746 121.959 10.2614 123.917 -0.00195312L123.41 -0.000441305Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.725 -0.000976562C55.6696 4.47629 55.6389 9.14396 56.2211 13.8409C57.3522 22.9659 60.7613 32.2248 63.3226 40.5047V40.5184L63.3382 40.5419C67.5847 49.0516 67.1183 57.5967 65.9808 66.2077C64.8433 74.8184 63.0237 83.4796 64.6449 92.1545L64.6508 92.1857L64.6664 92.215C68.4523 100.404 67.6095 107.959 64.807 115.18C62.0046 122.4 57.2282 129.264 53.1641 135.975L53.1504 135.996L53.1426 136.02C49.9884 144.5 47.7956 156.218 51.4746 164.998H52.0254C48.3298 156.399 50.4635 144.669 53.6152 136.196C57.6624 129.515 62.4433 122.65 65.2711 115.364C68.0982 108.08 68.9556 100.363 65.1364 92.061C63.5406 83.5131 65.3337 74.9081 66.4743 66.2741C67.6131 57.6533 68.0833 48.9843 63.7946 40.3563L63.779 40.3134C61.2135 32.0252 57.8338 22.8115 56.7145 13.7825C56.132 9.08377 56.1688 4.4414 57.236 -0.000368567H56.7243L56.725 -0.000976562Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.5661 28.4216C92.9769 26.8412 90.5501 27.5491 90.7022 29.1874C90.6916 30.6919 91.0724 32.5627 92.3779 33.4651C94.0664 34.3469 94.4668 31.9508 94.3108 30.7732C94.2828 29.9261 93.8228 29.2055 93.5661 28.4216L93.5661 28.4216Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.013 17.3232C83.3269 17.369 83.211 19.8943 84.8103 20.2808C86.2303 20.7778 88.1237 21.0232 89.4002 20.0802C90.7812 18.7682 88.6438 17.6136 87.479 17.3799C86.6686 17.132 85.8377 17.3341 85.013 17.3231V17.3232Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.8487 19.7064C97.0715 18.5447 95.4687 16.5899 94.0213 17.3721C92.6331 17.9524 91.0614 19.0362 90.7431 20.591C90.5939 22.4901 92.9551 21.9189 93.9773 21.3136C94.7456 20.9559 95.2281 20.25 95.8486 19.7065L95.8487 19.7064Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.045 54.777C84.2252 53.1 81.7381 52.6473 81.1411 54.1805C80.4586 55.5212 79.962 57.3648 80.7259 58.756C81.8414 60.3001 83.2715 58.3363 83.6589 57.2134C84.013 56.4433 83.9238 55.5929 84.0451 54.7771L84.045 54.777Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.698 61.592C101.991 60.0608 99.6244 60.9506 99.9002 62.5726C100.004 64.0736 100.525 65.9102 101.895 66.7112C103.646 67.4626 103.863 65.043 103.619 63.8806C103.527 63.0381 103.013 62.3543 102.698 61.5922L102.698 61.592Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.3498 128.996C93.8279 129.723 94.7481 132.078 96.3664 131.781C97.8659 131.658 99.6957 131.113 100.479 129.733C101.208 127.973 98.7855 127.786 97.6263 128.046C96.7851 128.149 96.108 128.671 95.35 128.996L95.3498 128.996Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.1552 127.106C90.4958 128.658 92.7443 129.814 93.7607 128.52C94.8032 127.435 95.8137 125.815 95.4868 124.262C94.8678 122.461 92.929 123.925 92.2322 124.887C91.6698 125.521 91.5081 126.361 91.1552 127.106L91.1552 127.106Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.7406 128.917C85.1296 128.417 84.2067 130.77 85.5962 131.651C86.7806 132.579 88.4941 133.421 90.0062 132.94C91.7362 132.142 90.0845 130.361 89.057 129.764C88.3696 129.269 87.5179 129.192 86.7407 128.917H86.7406Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.0138 138.815C89.5395 139.534 90.7814 137.332 89.5281 136.266C88.4847 135.182 86.9053 134.11 85.3408 134.376C83.5166 134.925 84.9039 136.919 85.8382 137.652C86.4499 138.239 87.2826 138.433 88.0138 138.815L88.0138 138.815Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.1159 134.133C91.4955 133.665 90.6185 136.036 92.0249 136.889C93.227 137.794 94.9565 138.603 96.4591 138.092C98.1732 137.261 96.487 135.512 95.4483 134.936C94.7514 134.453 93.8984 134.394 93.1159 134.133V134.133Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.0382 87.5198C72.7903 89.0295 75.1292 88.0703 74.8057 86.4571C74.6579 84.9599 74.0825 83.1394 72.6894 82.3793C70.9176 81.6799 70.7713 84.1049 71.0503 85.2595C71.167 86.099 71.7005 86.7673 72.0381 87.5198L72.0382 87.5198Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.4327 130.496C68.1179 130.567 68.4072 128.055 66.8383 127.56C65.4559 126.966 63.5838 126.591 62.2454 127.444C60.7774 128.658 62.8304 129.957 63.9763 130.27C64.7677 130.573 65.6105 130.429 66.4326 130.496H66.4327Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.5142 63.3116C71.1826 64.8602 73.5705 64.0305 73.3358 62.4021C73.2702 60.899 72.7954 59.0498 71.4459 58.2143C69.715 57.419 69.4362 59.8322 69.6516 61.0004C69.7222 61.845 70.2182 62.5415 70.5142 63.3114L70.5142 63.3116Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.9815 51.6328C71.3499 50.0688 68.9431 50.8419 69.1393 52.4755C69.1691 53.9797 69.6004 55.8396 70.9298 56.7067C72.6414 57.5427 72.9771 55.1367 72.7893 53.9636C72.7387 53.1176 72.2592 52.4096 71.9816 51.6329L71.9815 51.6328Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.6385 56.0852C72.9685 55.849 72.4328 58.3195 73.945 58.9675C75.2622 59.6946 77.0881 60.2526 78.5039 59.5358C80.0845 58.4727 78.1698 56.9775 77.0604 56.5528C76.3028 56.1731 75.4498 56.2337 74.6385 56.0852H74.6385Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.5911 61.4516C76.9048 61.4149 76.6658 63.9317 78.2443 64.3958C79.6384 64.9615 81.5175 65.299 82.8387 64.4196C84.2821 63.1765 82.2036 61.9189 81.0516 61.6288C80.2543 61.3416 79.4145 61.5029 78.5913 61.4517L78.5911 61.4516Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.0824 54.7696C77.0653 56.1402 79.2216 54.8209 78.6454 53.2798C78.2612 51.8252 77.4032 50.1196 75.9068 49.5909C74.0462 49.1825 74.2879 51.5998 74.7472 52.6953C74.9961 53.5055 75.6291 54.0803 76.0823 54.7695L76.0824 54.7696Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.0505 9.26229C81.4172 10.2508 83.0442 8.316 82.0092 7.03701C81.1838 5.77913 79.8295 4.43339 78.2426 4.40625C76.3485 4.60862 77.3439 6.82467 78.1267 7.71816C78.6196 8.40766 79.4022 8.7522 80.0504 9.26225L80.0505 9.26229Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.8071 27.8353C82.1955 28.3328 82.7628 30.7962 84.4071 30.7385C85.9085 30.8354 87.7982 30.5628 88.774 29.3112C89.7514 27.6762 87.3822 27.1388 86.1976 27.2269C85.3503 27.206 84.6044 27.6241 83.8071 27.8352L83.8071 27.8353Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.7029 26.627C98.3815 26.4623 98.319 23.9351 96.6965 23.6624C95.2449 23.2668 93.3389 23.1556 92.1319 24.1863C90.8469 25.5925 93.0605 26.5934 94.2388 26.7443C95.0647 26.9344 95.8792 26.6742 96.7027 26.627L96.7029 26.627Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.9475 25.231C90.6341 25.2222 90.8053 22.7001 89.215 22.2786C87.8062 21.7505 85.9187 21.4636 84.6217 22.3784C83.2122 23.6598 85.3238 24.861 86.4831 25.1201C87.2879 25.3858 88.123 25.202 88.9474 25.231L88.9475 25.231Z",
  fill: "#E9AFAF",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1086_400"
}, /*#__PURE__*/React.createElement("rect", {
  width: 165,
  height: 165,
  fill: "white"
})));

var SvgD3 = function SvgD3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d_3.ea180f80.svg";
export { ForwardRef as ReactComponent };